// extracted by mini-css-extract-plugin
module.exports = {"text__error":"warning_text__error__1-PPF"};